import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useLanguage } from '../composables/useLanguage.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/nueva-partida',
    name: 'nueva-partida',
    component: () => import('../views/NuevaPartidaView.vue')
  },
  {
    path: '/continue-partida',
    name: 'continue-partida',
    component: () => import('../views/ContinuePartidaView.vue')
  },
  {
    path: '/game/:gameId/crear-partida/:partidaCode?',
    name: 'crear-partida',
    component: () => import('../views/CreatePartidaView.vue')
  },
  {
    path: '/partida/:partidaCode',
    name: 'partida',
    component: () => import('../views/PartidaView.vue')
  },
  {
    path: '/:lang',
    name: 'language-switch',
    beforeEnter: async (to, from, next) => {
      try {
        console.log('🌐 Verificando idioma:', to.params.lang)
        
        // Usar el composable useLanguage
        const { language, getAvailableLanguages } = useLanguage()
        
        // Obtener idiomas activos
        const activeLanguages = await getAvailableLanguages()
        
        // Verificar si el idioma existe
        const languageExists = activeLanguages.data.some(lang =>
          lang.code === to.params.lang
        )
        
        if (languageExists) {
          console.log('✅ Idioma válido, estableciendo:', to.params.lang)
          
          // Establecer el idioma usando el composable
          language.value = to.params.lang
          
          // Redirigir a la página principal
          next({ name: 'home' })
        } else {
          console.log('❌ Idioma no válido:', to.params.lang)
          
          // Si el idioma no existe, ir a 404
          next({ name: 'not-found' })
        }
      } catch (error) {
        console.error('❌ Error al verificar idioma:', error)
        
        // En caso de error, ir a la página principal
        next({ name: 'home' })
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
